// ✅ src/components/ProtectedRoute.jsx (Final No-Flash Version)
import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

export default function ProtectedRoute({ children }) {
  const [authStatus, setAuthStatus] = useState("checking");
  const location = useLocation();

  useEffect(() => {
    const checkAuth = () => {
      try {
        const path = location.pathname;
        const isAdmin = path.startsWith("/admin");

        // 🧠 First priority → Suspended user
        const userData = JSON.parse(localStorage.getItem("user") || "{}");
        if (userData?.status === "suspended") {
          setAuthStatus("suspended");
          return;
        }

        // 👑 Admin Check
        if (isAdmin) {
          const adminToken = localStorage.getItem("adminToken");
          const admin = JSON.parse(localStorage.getItem("admin") || "{}");
          if (adminToken && admin?.username) {
            setAuthStatus("admin-ok");
          } else {
            setAuthStatus("unauth");
          }
          return;
        }

        // 👤 Normal User Check
        const token = localStorage.getItem("token");
        if (token && userData?.username) {
          setAuthStatus("ok");
        } else {
          setAuthStatus("unauth");
        }
      } catch (err) {
        console.error("Auth check error:", err);
        setAuthStatus("unauth");
      }
    };

    checkAuth();
  }, [location.pathname]);

  // 🕒 Checking
  if (authStatus === "checking") return null;

  const isAdminRoute = location.pathname.startsWith("/admin");

  // 🚫 Suspended user — block all except /account-suspended
  if (authStatus === "suspended") {
    if (location.pathname !== "/account-suspended") {
      return <Navigate to="/account-suspended" replace />;
    }
    return children;
  }

  // ❌ Unauthorized user redirect
  if (authStatus === "unauth") {
    if (location.pathname === "/account-suspended") return children;
    return (
      <Navigate
        to={isAdminRoute ? "/admin/login" : "/login"}
        state={{ from: location }}
        replace
      />
    );
  }

  // ✅ Everything OK — show the real page
  return children;
}